<span class="td-wb-vh"
      [tdWbScreenReaderVisibility]="menuOpened"></span>
<ng-template>
  <div [attr.id]="getMenuId()"
       [class]="'td-wb-flyout-menu__panel ' + getPositionClass()"
       (keydown)="handleKeydown($event, $event.key)"
       tabindex="0"
       role="menu">
    <div class="td-wb-flyout-menu__panel-content">
      <ng-content select="td-wb-flyout-menu-header"/>
      <ng-content/>
      <ng-content select="td-wb-flyout-menu-footer"/>
      @if (platformIOS) {
        <button class="td-wb-vh"
                (click)="closeButtonClick()"
                translate="tdWb.dropdown.CLOSE_ARIA">
          <td-wb-icon iconId="cross"/>
        </button>
      }
    </div>
  </div>
</ng-template>
